import { render, staticRenderFns } from "./DiyNewDashboard.vue?vue&type=template&id=2478daba&scoped=true"
import script from "./DiyNewDashboard.vue?vue&type=script&lang=js"
export * from "./DiyNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./DiyNewDashboard.vue?vue&type=style&index=0&id=2478daba&prod&scoped=true&lang=css"
import style1 from "./DiyNewDashboard.vue?vue&type=style&index=1&id=2478daba&prod&scoped=true&lang=css"
import style2 from "./DiyNewDashboard.vue?vue&type=style&index=2&id=2478daba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478daba",
  null
  
)

export default component.exports